import { s as styles } from "./debug.css.js";
const debugKey = Symbol.for("@constructor/debug");
function isDebugEnabled() {
  var _a, _b;
  return ((_b = (_a = globalThis.window) == null ? void 0 : _a[debugKey]) == null ? void 0 : _b.enabled) === true;
}
function registerDebugPlugin(name, plugin) {
  var _a, _b;
  if (!globalThis.window) {
    return;
  }
  if (((_a = window[debugKey]) == null ? void 0 : _a.enabled) === false) {
    return;
  }
  if (window[debugKey] && "registerPlugin" in window[debugKey]) {
    window[debugKey].registerPlugin(name, plugin);
    return;
  }
  if (!window[debugKey]) {
    window[debugKey] = { autoRegisterPlugins: [] };
  }
  (_b = window[debugKey]).autoRegisterPlugins ?? (_b.autoRegisterPlugins = []);
  window[debugKey].autoRegisterPlugins.push([name, plugin]);
}
function useFederationDebug(versions) {
  return {
    register
  };
  function register() {
    if (typeof globalThis.window === "undefined" || !isDebugEnabled()) {
      return;
    }
    versions.setVersionResolver(getOverride, true);
    warnOverrides();
    registerDebugPlugin("@constructor/federation", {
      section: {
        title: "Fragments",
        table: () => ({
          columns: ["Name", "Version"],
          rows: [...versions.getVersions().keys()].map((name) => [name, renderVersion(name)])
        })
      }
    });
  }
  function warnOverrides() {
    const overrides = Object.entries(getOverrides());
    if (overrides.length > 0) {
      for (const [name, value] of overrides) {
        console.warn(`Version for fragment "${name}" is overridden to "${value}"`);
      }
    }
  }
  function isOverridden(name) {
    return name in getOverrides();
  }
  function removeOverride(name) {
    const overrides = getOverrides();
    delete overrides[name];
    setOverrides(overrides);
  }
  function setOverrides(overrides) {
    if (Object.keys(overrides).length === 0) {
      localStorage.removeItem("federation-versions-overrides");
    } else {
      localStorage.setItem("federation-versions-overrides", JSON.stringify(overrides));
    }
  }
  function getOverride(name) {
    return getOverrides()[name];
  }
  function setOverride(name, version) {
    if (versions.getVersion(name) === version) {
      removeOverride(name);
    } else {
      const overrides = getOverrides();
      overrides[name] = version;
      setOverrides(overrides);
    }
  }
  function getOverrides() {
    try {
      return JSON.parse(localStorage.getItem("federation-versions-overrides") ?? "{}");
    } catch {
      return {};
    }
  }
  function renderVersion(name) {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styles);
    return () => {
      const el = document.createElement("div");
      el.ondblclick = edit;
      const shadow = el.attachShadow({ mode: "open" });
      shadow.adoptedStyleSheets = [sheet];
      const span = document.createElement("span");
      span.classList.toggle("overridden", isOverridden(name));
      span.innerText = versions.getVersion(name);
      shadow.replaceChildren(span);
      setButton();
      return el;
      function cancel() {
        stopEdit();
        span.innerText = versions.getVersion(name);
      }
      function save() {
        const newVersion = span.innerText.trim() || versions.getVersion(name);
        stopEdit();
        setOverride(name, newVersion);
        setButton();
        span.classList.toggle("overridden", isOverridden(name));
        span.innerText = newVersion;
      }
      function reset() {
        removeOverride(name);
        setButton();
        span.classList.toggle("overridden", isOverridden(name));
        span.innerText = versions.getVersion(name);
      }
      function stopEdit() {
        span.onblur = null;
        span.onkeydown = null;
        window.removeEventListener("unload", save);
        span.contentEditable = "false";
      }
      function edit() {
        span.contentEditable = "true";
        span.onkeydown = (event) => {
          if (event.key === "Enter") {
            save();
            event.preventDefault();
          } else if (event.key === "Escape") {
            cancel();
            event.preventDefault();
          }
        };
        span.onblur = save;
        window.addEventListener("unload", save);
        const selection = window.getSelection();
        selection.selectAllChildren(span);
      }
      function setButton() {
        const existingButton = shadow.querySelector("button");
        if (!isOverridden(name)) {
          existingButton && shadow.removeChild(existingButton);
          return;
        }
        if (existingButton) {
          return;
        }
        const button = document.createElement("button");
        button.innerText = "Reset";
        button.onclick = reset;
        shadow.appendChild(button);
      }
    };
  }
}
export {
  debugKey as d,
  registerDebugPlugin as r,
  useFederationDebug as u
};
//# sourceMappingURL=debug.js.map
